import { useState, useEffect } from "react";
import {
  TextField,
  Grid,
  Typography,
  InputAdornment,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setCsvDialog, resetExcelForm, Pins } from "../../app/slices/pinsSlice";
import { Controller, useForm } from "react-hook-form";
import { SelectItem } from "../Selectors/SelectItems";
import FilePondInput from "../../helpers/FilePondInput";
import { SelectSupplier } from "../Selectors/SelectSupplier";
import { NumericFormat } from "react-number-format";
import {
  HiOutlineDocumentArrowUp,
  HiOutlineTag,
  HiOutlineArrowUpTray,
} from "react-icons/hi2";
import FormDialog, { SectionCard, SwitchCard } from "../FormDialog";

const PinsCsvForm = () => {
  const _Pins = useSelector((state) => state.pins.pin);

  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: _Pins.excelForm,
  });

  const [disableButton, setDisabelButton] = useState(false);

  const onSubmit = (data) => {
    setDisabelButton(true);
    const formData = new FormData();
    formData.append("upload_file", data.upload_file[0]);
    formData.append("buying_price", data.buying_price);
    formData.append("cash_paid", data.cash_paid ?? "");
    formData.append("is_initial", data.is_initial ?? "");
    formData.append("item_id", _Pins.selectedItem?.id ?? data.item_id.id);
    formData.append("supplier_id", data.supplier_id.id);
    formData.append("note", data.note);
    formData.append("is_private", data.is_private);
    dispatch(Pins.importCsvFile(formData))
      .then(() => setDisabelButton(false))
      .catch(() => setDisabelButton(false));
  };

  useEffect(() => {
    reset({ ..._Pins.excelForm });
  }, [_Pins.excelForm]);

  useEffect(() => {
    return () => {
      dispatch(resetExcelForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setCsvDialog());
  };

  return (
    <Box>
      <FormDialog
        open={_Pins.csvDialog}
        onClose={() => {
          handleDialog();
        }}
        maxWidth="sm"
        icon={<HiOutlineDocumentArrowUp />}
        title={"رفع مستند txt, csv"}
        subtitle="أدخل معلومات الكارتات ثم ارفع الملف لاستيرادها"
        onSubmit={handleSubmit(onSubmit)}
        saving={disableButton}
      >
        <SectionCard icon={<HiOutlineTag />} title="المعلومات الأساسية">
          {_Pins.selectedItem ? (
            <Grid item xs={12}>
              <Typography variant="h4">
                المنتج: {_Pins.selectedItem.name}
              </Typography>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6}>
              <Controller
                name="item_id"
                control={control}
                render={({ field }) => (
                  <SelectItem
                    required
                    value={field.value}
                    onChange={(e, newValue) => {
                      setValue("item_id", newValue);
                    }}
                  />
                )}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <Controller
              name="supplier_id"
              control={control}
              render={({ field }) => (
                <SelectSupplier
                  required
                  value={field.value}
                  onChange={(e, newValue) => {
                    setValue("supplier_id", newValue);
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="buying_price"
              control={control}
              render={({ field: { onChange, ...renderProps } }) => {
                return (
                  <NumericFormat
                    customInput={TextField}
                    label="سعر الشراء للكارت"
                    size="small"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          IQD
                        </InputAdornment>
                      ),
                    }}
                    {...renderProps}
                    onValueChange={(target) => {
                      onChange();
                      setValue("buying_price", target.floatValue);
                    }}
                    isNumericString
                    thousandSeparator
                    error={
                      watch("buying_price") >
                      watch("item_id")?.selling_price
                    }
                    helperText={
                      watch("buying_price") >
                      watch("item_id")?.selling_price
                        ? `سعر البيع (${
                            watch("item_id")?.selling_price
                          } IQD) يجب ان يكون اعلى من سعر الشراء`
                        : null
                    }
                  />
                );
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="is_private"
              control={control}
              render={({ field }) => (
                <SwitchCard
                  field={field}
                  label={"اخفاء عن اسياسيل"}
                  onChange={(e) => setValue("is_private", e.target.checked)}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="note"
              control={control}
              render={({ field }) => (
                <TextField
                  multiline
                  size="small"
                  label="ملاحظات"
                  fullWidth
                  {...field}
                />
              )}
            />
          </Grid>
        </SectionCard>
        <SectionCard icon={<HiOutlineArrowUpTray />} title="الملف">
          <Grid item xs={12}>
            <Controller
              name="upload_file"
              control={control}
              render={({ field }) => (
                <Box>
                  <FilePondInput field={field} required={true} />
                </Box>
              )}
            />
          </Grid>
        </SectionCard>
      </FormDialog>
    </Box>
  );
};

export default PinsCsvForm;
